import { type z } from "zod"
import { type ProviderCalendarIdSchema } from "../schemas/providerCalendarId"

export type ProviderCalendarId = z.infer<typeof ProviderCalendarIdSchema>

export const ProviderCalendarId = {
    BASE: "BASE",
    HPHC_2_SAISONS: "HPHC_2_SAISONS",
    EFFACEMENT_BASE_1: "EFFACEMENT_BASE_1",
    EFFACEMENT_HPHC_2: "EFFACEMENT_HPHC_2",
    HPHC: "HPHC",
    OCTOFLEX_4_V4: "OCTOFLEX_4_V4",
    OEFR_Base_opti_CS_hiver_ete: "OEFR_Base_opti_CS_hiver_ete",
    OEFR_HPHC_opti_CS_8h: "OEFR_HPHC_opti_CS_8h",
} as const satisfies Record<ProviderCalendarId, ProviderCalendarId>
